// TODO: Investigate other options for implementing abstract methods in
// superclasses. The linter doesn't like it 😭 -- Jack 17/5/18
/* eslint-disable */
import { Component } from "react";

export default class DynamicFormComponent extends Component {
  getSelectedValues() {
    throw new TypeError(
      "This method has not been implemented by its extended class."
    );
  }

  validate() {
    throw new TypeError(
      "This method has not been implemented by its extended class."
    );
  }
}
